import { FallbackRender } from '@sentry/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { ErrorAccordion } from './common';

export const MainBoundary: FallbackRender = ({ error, eventId, resetError }) => {
  const { t } = useTranslation('base');

  if (!(error instanceof Error)) {
    return <Text weight='bold'>{t('Something went wrong.')}</Text>;
  }
  return (
    <div
      style={{
        display: 'grid',
        height: '100%',
        alignContent: 'center',
        justifyItems: 'center',
        gap: theme.spacing(2),
      }}
    >
      <Text weight='bold'>{t('Something went wrong.')}</Text>
      <ErrorAccordion error={error} eventId={eventId} />
      <Button onClick={resetError}>{t('Try again')}</Button>
    </div>
  );
};
